import { createAction, props } from '@ngrx/store';
import { GMB_STATUS, IGmbLocation } from '@boxx/gmb-core';
import {
  IBusinessUpdateInfoPayload,
  IRatingAppProps,
  ITokenEcwid,
  OnboardingBusinessConfigScheduleDataProps,
  OnboardingBusinessConfigServicesDataProps,
  UpdateMetaPayloadProps,
} from '../..';
import {
  BusinessModel,
  IndexedImage,
  OnboardingBusinessConfigGmbStatusDataProps,
  OnboardingBusinessConfigNotificationsDataProps,
  OnboardingBusinessConfigPaymentsDataProps,
  OnboardingBusinessConfigSocialNetworksDataProps,
  OnboardingBusinessConfigWebsiteDataProps,
} from '../models/BusinessConfig.model';
import {
  BusinessSiteFields,
  BusinessUpdatePayloadProps,
  IDeleteImageFormProps,
  IGetSiteImagesProps,
  IWizardCreateUserPayloadProps,
} from '../repositories/IOnboarding.api';

export enum OnboardingRegistrationActionType {
  createUserBegin = '[ONBOARDING] Registration: Create User Begin',
  createUserSuccess = '[ONBOARDING] Registration: Create User Success',
  createUserFail = '[ONBOARDING] Registration: Create User Fail',
  

  clearOnboardingRegistraionSuccessErrorData = '[ONBOARDING] Clear Onboarding Registraion Success/Error Data',
}

export const createUserBeginAction = createAction(
  OnboardingRegistrationActionType.createUserBegin,
  props<{ payload: IWizardCreateUserPayloadProps }>()
);

export const createUserSuccessAction = createAction(
  OnboardingRegistrationActionType.createUserSuccess,
  props<{
    payload: IWizardCreateUserPayloadProps;
  }>()
);

export const createUserFailAction = createAction(
  OnboardingRegistrationActionType.createUserFail,
  props<{ errors: any }>()
);

export const clearOnboardingRegistraionSuccessErrorDataAction = createAction(
  OnboardingRegistrationActionType.clearOnboardingRegistraionSuccessErrorData
);

//--------------------------------------------------------------------------------

export enum OnboardingBusinessConfigActionType {
  getLocationStatusBegin = '[ONBOARDING] Get Location Status Begin',
  getLocationStatusSuccess = '[ONBOARDING] Get Location Status Success',
  getLocationStatusFail = '[ONBOARDING] Get Location Status Fail',

  prefillServicesData = '[ONBOARDING] Prefill Services Data',
  prefillScheduleData = '[ONBOARDING] Prefill Schedule Data',

  getBusinessDataBegin = '[ONBOARDING] Get Business Data Begin',
  getBusinessDataSuccess = '[ONBOARDING] Get Business Data Success',
  getBusinessDataFail = '[ONBOARDING] Get Business Data Fail',

  updateBusinessDataBegin = '[ONBOARDING] Updata Business Data Begin',
  updateBusinessDataSuccess = '[ONBOARDING] Updata Business Data Success',
  updateBusinessDataFail = '[ONBOARDING] Updata Business Data Fail',

  updateBusinessInfoBegin = '[ONBOARDING] Updata Business Info Begin',
  updateBusinessInfoSuccess = '[ONBOARDING] Updata Business Info Success',
  updateBusinessInfoFail = '[ONBOARDING] Updata Business Info Fail',

  updateStoreDataBegin = '[ONBOARDING] Updata Store Data Begin',
  updateStoreDataSuccess = '[ONBOARDING] Updata Store Data Success',
  updateStoreDataFail = '[ONBOARDING] Updata Store Data Fail',

  setServicesCompleted = '[ONBOARDING] Set Services Completed',
  setScheduleCompleted = '[ONBOARDING] Set Schedule Completed',
  setPaymentMethodsCompleted = '[ONBOARDING] Set Payment Methods Completed',
  setSocialNetworksCompleted = '[ONBOARDING] Set Social Networks Completed',
  setGmbStatusCompleted = '[ONBOARDING] Set Gmb Status Completed',
  setNotificationsCompleted = '[ONBOARDING] Set Notifications Completed',
  setWebsiteCompleted = '[ONBOARDING] Set Website Completed',
  setModuleCompleted = '[ONBOARDING] Set Module Completed',

  getGmbStatusBegin = '[ONBOARDING] Get Gmb Status Begin',
  getGmbStatusSuccess = '[ONBOARDING] Get Gmb Status Success',
  getGmbStatusFail = '[ONBOARDING] Get Gmb Status Fail',

  createWebsiteBegin = '[ONBOARDING] Create Website Data Begin',
  createWebsiteSuccess = '[ONBOARDING] Create Website Data Success',
  createWebsiteFail = '[ONBOARDING] Create Website Data Fail',
  updateWebsiteSuccess = '[ONBOARDING] Update Website upload image Success',

  deleteBusinessImageBegin = '[ONBOARDING] Delete Business Image Begin',
  deleteBusinessImageSuccess = '[ONBOARDING] Delete Business Image Success',
  deleteBusinessImageFail = '[ONBOARDING] Delete Business Image Fail',

  updateMetaBegin = '[ONBOARDING] Update Meta Begin',
  updateMetaSuccess = '[ONBOARDING] Update Meta Success',
  updateMetaFail = '[ONBOARDING] Update Meta Fail',

  updateScoreBegin = '[ONBOARDING] Update Score Begin',
  updateScoreSuccess = '[ONBOARDING] Update Score Success',
  updateScoreFail = '[ONBOARDING] Update Score Fail',

  removeLogoSite = '[SITE] Remove Site Image Success',
  removeBannerSite = '[SITE] Remove Banner Image Success',
  removeMainSite = '[SITE] Remove Main Image Success',
  removeContactSite = '[SITE] Remove Contact Image Success',
  removeSpotlightSite = '[SITE] Remove Spotlight Image Success',
  removeGalleryImageSite = '[SITE] Remove Gallery Image Success',
  updateFieldsSite = '[SITE] Update Fields Site Success',
  updateImagesSite = '[SITE] Update Images Site Success',
  clearRemoveImageSuccessErrorData = '[SITE] Clear Image deleted Success/Error Data',

  updateBusinessNFCSuccess = '[PANEL] Updata Business Data NFC success',

  clearOnboardingBusinessConfigSuccessErrorData = '[ONBOARDING] Clear Onboarding Business Config Success/Error Data',
}

export const prefillServicesDataAction = createAction(
  OnboardingBusinessConfigActionType.prefillServicesData,
  props<{ payload: OnboardingBusinessConfigServicesDataProps }>()
);

// ----------------------------------------------------------------

export const prefillScheduleDataAction = createAction(
  OnboardingBusinessConfigActionType.prefillScheduleData,
  props<{ payload: OnboardingBusinessConfigScheduleDataProps }>()
);

// -----------------------------------------------------

export const getBusinessDataBeginAction = createAction(
  OnboardingBusinessConfigActionType.getBusinessDataBegin
);

export const getBusinessDataSuccessAction = createAction(
  OnboardingBusinessConfigActionType.getBusinessDataSuccess,
  props<{ payload: BusinessModel }>()
);

export const getBusinessDataFailAction = createAction(
  OnboardingBusinessConfigActionType.getBusinessDataFail,
  props<{ errors: any }>()
);

// -----------------------------------------------------

export const updateBusinessDataBeginAction = createAction(
  OnboardingBusinessConfigActionType.updateBusinessDataBegin,
  props<{ payload: BusinessUpdatePayloadProps }>()
);

export const updateBusinessDataSuccessAction = createAction(
  OnboardingBusinessConfigActionType.updateBusinessDataSuccess,
  props<{ payload: BusinessModel }>()
);

export const updateBusinessDataFailAction = createAction(
  OnboardingBusinessConfigActionType.updateBusinessDataFail,
  props<{ errors: any }>()
);

// -----------------------------------------------------

export const updateBusinessInfoBeginAction = createAction(
  OnboardingBusinessConfigActionType.updateBusinessInfoBegin,
  props<{ payload: IBusinessUpdateInfoPayload }>()
);

export const updateBusinessInfoSuccessAction = createAction(
  OnboardingBusinessConfigActionType.updateBusinessInfoSuccess,
  props<{ payload: BusinessModel }>()
);

export const updateBusinessInfoFailAction = createAction(
  OnboardingBusinessConfigActionType.updateBusinessInfoFail,
  props<{ errors: any }>()
);

// -----------------------------------------------------

export const updateStoreInfoBeginAction = createAction(
  OnboardingBusinessConfigActionType.updateStoreDataBegin,
  props<{ payload: ITokenEcwid }>()
);

export const updateStoreInfoSuccessAction = createAction(
  OnboardingBusinessConfigActionType.updateStoreDataSuccess,
  props<{ payload: any }>()
);

export const updateStoreInfoFailAction = createAction(
  OnboardingBusinessConfigActionType.updateStoreDataFail,
  props<{ errors: any }>()
);

// ----------------------------------------------------------------

export const setServicesCompletedAction = createAction(
  OnboardingBusinessConfigActionType.setServicesCompleted,
  props<{ payload: OnboardingBusinessConfigServicesDataProps }>()
);
export const setScheduleCompletedAction = createAction(
  OnboardingBusinessConfigActionType.setScheduleCompleted,
  props<{ payload: OnboardingBusinessConfigScheduleDataProps }>()
);
export const setPaymentMethodsCompletedAction = createAction(
  OnboardingBusinessConfigActionType.setPaymentMethodsCompleted,
  props<{ payload: OnboardingBusinessConfigPaymentsDataProps }>()
);
export const setSocialNetworksCompletedAction = createAction(
  OnboardingBusinessConfigActionType.setSocialNetworksCompleted,
  props<{ payload: OnboardingBusinessConfigSocialNetworksDataProps }>()
);
export const setGmbStatusCompletedAction = createAction(
  OnboardingBusinessConfigActionType.setGmbStatusCompleted,
  props<{ payload: OnboardingBusinessConfigGmbStatusDataProps }>()
);
export const setNotificationsCompletedAction = createAction(
  OnboardingBusinessConfigActionType.setNotificationsCompleted,
  props<{ payload: OnboardingBusinessConfigNotificationsDataProps }>()
);
export const setWebsiteCompletedAction = createAction(
  OnboardingBusinessConfigActionType.setWebsiteCompleted,
  props<{ payload: OnboardingBusinessConfigWebsiteDataProps }>()
);
export const setModuleCompletedAction = createAction(
  OnboardingBusinessConfigActionType.setModuleCompleted
);

// ----------------------------------------------------------------

export const getGmbStatusBeginAction = createAction(
  OnboardingBusinessConfigActionType.getGmbStatusBegin
);

export const getGmbStatusSuccessAction = createAction(
  OnboardingBusinessConfigActionType.getGmbStatusSuccess,
  props<{ payload: any }>()
);

export const getGmbStatusFailAction = createAction(
  OnboardingBusinessConfigActionType.getGmbStatusFail,
  props<{ errors: any }>()
);

// ----------------------------------------------------------------

export const createWebsiteBeginAction = createAction(
  OnboardingBusinessConfigActionType.createWebsiteBegin
);

export const createWebsiteSuccessAction = createAction(
  OnboardingBusinessConfigActionType.createWebsiteSuccess,
  props<{ payload: any }>()
);

export const createWebsiteFailAction = createAction(
  OnboardingBusinessConfigActionType.createWebsiteFail,
  props<{ errors: any }>()
);

export const updateWebsiteImageSuccessAction = createAction(
  OnboardingBusinessConfigActionType.updateWebsiteSuccess,
  props<{ payload: string }>()
);

export const removeLogoSite = createAction(
  OnboardingBusinessConfigActionType.removeLogoSite,
  props<{ payload: string }>()
);

export const removeBannerSite = createAction(
  OnboardingBusinessConfigActionType.removeBannerSite,
  props<{ payload: string }>()
);

export const removeMainImageSite = createAction(
  OnboardingBusinessConfigActionType.removeMainSite,
  props<{ payload: string }>()
);

export const removeContactImageSite = createAction(
  OnboardingBusinessConfigActionType.removeContactSite,
  props<{ payload: string }>()
);

export const removeSpotlightImageSite = createAction(
  OnboardingBusinessConfigActionType.removeSpotlightSite,
  props<{ payload: string }>()
);

export const removeGalleryImageSite = createAction(
  OnboardingBusinessConfigActionType.removeGalleryImageSite,
  props<{ payload: any[] }>()
);

export const updateFieldsSite = createAction(
  OnboardingBusinessConfigActionType.updateFieldsSite,
  props<{ payload: BusinessSiteFields }>()
);

export const updateImagesSite = createAction(
  OnboardingBusinessConfigActionType.updateImagesSite,
  props<{ payload: any }>()
);

export const clearRemoveImageSite = createAction(
  OnboardingBusinessConfigActionType.clearRemoveImageSuccessErrorData
);



// ----------------------------------------------------------------

export const deleteBusinessImageBeginAction = createAction(
  OnboardingBusinessConfigActionType.deleteBusinessImageBegin,
  props<{ payload: IDeleteImageFormProps }>()
);

export const deleteBusinessImageSuccessAction = createAction(
  OnboardingBusinessConfigActionType.deleteBusinessImageSuccess,
  props<{
    payload: {
      logo?: IndexedImage;
      about?: IndexedImage;
      gallery?: IndexedImage[];
    };
  }>()
);

export const deleteBusinessImageFailAction = createAction(
  OnboardingBusinessConfigActionType.deleteBusinessImageFail,
  props<{ errors: any }>()
);

// ----------------------------------------------------------------

export const updateMetaBeginAction = createAction(
  OnboardingBusinessConfigActionType.updateMetaBegin,
  props<{ payload: UpdateMetaPayloadProps }>()
);

export const updateMetaSuccessAction = createAction(
  OnboardingBusinessConfigActionType.updateMetaSuccess,
  props<{ payload: BusinessModel }>()
);

export const updateMetaFailAction = createAction(
  OnboardingBusinessConfigActionType.updateMetaFail,
  props<{ errors: any }>()
);

// -----------------------------------------------------

export const getLocationStatusBeginAction = createAction(
  OnboardingBusinessConfigActionType.getLocationStatusBegin
);

export const getLocationStatusSuccessAction = createAction(
  OnboardingBusinessConfigActionType.getLocationStatusSuccess,
  props<{ payload: { status: GMB_STATUS; data: IGmbLocation } }>()
);

export const getLocationStatusFailAction = createAction(
  OnboardingBusinessConfigActionType.getLocationStatusFail,
  props<{ errors: any }>()
);

// ----------------------------------------------------------------
export const clearBusinessConfigSuccessErrorDataAction = createAction(
  OnboardingBusinessConfigActionType.clearOnboardingBusinessConfigSuccessErrorData
);

// -----------------------------------------------------

export const updateScoreInfoBeginAction = createAction(
  OnboardingBusinessConfigActionType.updateScoreBegin,
  props<{ payload: IRatingAppProps }>()
);

export const updateScoreInfoSuccessAction = createAction(
  OnboardingBusinessConfigActionType.updateScoreSuccess,
  props<{ payload: any }>()
);

export const updateScoreInfoFailAction = createAction(
  OnboardingBusinessConfigActionType.updateScoreFail,
  props<{ errors: any }>()
);

export const updateBusinessNFCAction = createAction(
  OnboardingBusinessConfigActionType.updateBusinessNFCSuccess
);
